interface Props {
  color?: string
  title?: string
  width?: string
}

export function DownArrowIcon ({ color = '#9a9797', title = '', width }: Props): JSX.Element {
  return (
    <svg
      style={{ verticalAlign: 'bottom' }}
      width={width ?? '16px'}
      height='16px'
      viewBox='0 0 16 16'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g
        id='down'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <polygon
          id='Path-7'
          fill={color}
          fillRule='nonzero'
          transform='translate(8.000000, 8.080635) rotate(-180.000000) translate(-8.000000, -8.080635) '
          points='0.458371402 9.669636 8 4.81039888 15.5416286 9.669636 14.4583714 11.3508718 8 7.189 1.5416286 11.3508718'
        />
      </g>
    </svg>
  )
}
